import AlwaysFailServiceError from './AlwaysFailServiceError';
import { ServiceError, ServiceErrorType, UserErrorResponse, UserResponseOptions } from './serviceError';

export default class ServiceErrorProvider {
  private static serviceError: ServiceError = new AlwaysFailServiceError();

  public static notifyUser(
    errorType: ServiceErrorType,
    options: UserResponseOptions = UserResponseOptions.all,
  ): Promise<UserErrorResponse> {
    return this.serviceError.notifyUser(errorType, options);
  }

  public static setServiceError(serviceError: ServiceError): void {
    this.serviceError = serviceError;
  }
}
